import { render, staticRenderFns } from "./newSamples.vue?vue&type=template&id=6508de92&scoped=true&"
import script from "./newSamples.vue?vue&type=script&lang=js&"
export * from "./newSamples.vue?vue&type=script&lang=js&"
import style0 from "./newSamples.vue?vue&type=style&index=0&id=6508de92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508de92",
  null
  
)

export default component.exports